var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEuFlag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 31"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#eu-flag_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#039",
  d: "M0 .31h40v30H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m20 5.084-.445 1.481.74.149z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m19.999 5.084.444 1.481-.74.149z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m21.409 6.107-1.546.035.088.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m21.409 6.108-1.272.88-.37-.659z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m20.87 7.763-.511-1.46-.687.316z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m20.87 7.763-1.23-.937.512-.555z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m18.59 6.107 1.547.035-.088.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m18.59 6.108 1.272.88.37-.659z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m19.13 7.763.51-1.46.687.316z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m19.129 7.763 1.23-.937-.512-.555zM20 22.861l-.445 1.482.74.148z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m19.999 22.861.444 1.482-.74.148z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m21.409 23.885-1.546.035.088.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m21.409 23.885-1.272.88-.37-.658z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m20.87 25.54-.511-1.46-.687.316z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m20.87 25.54-1.23-.937.512-.555z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m18.59 23.885 1.547.035-.088.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m18.59 23.885 1.272.88.37-.658z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m19.13 25.54.51-1.46.687.316z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m19.129 25.54 1.23-.937-.512-.555zM11.11 13.973l-.444 1.481.74.148z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m11.11 13.973.445 1.481-.741.148z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m12.52 14.996-1.546.035.088.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m12.52 14.996-1.272.88-.37-.658z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m11.981 16.652-.511-1.46-.686.316z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m11.982 16.652-1.23-.938.511-.555z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m9.702 14.996 1.546.035-.088.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m9.702 14.996 1.271.88.37-.658z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m10.24 16.652.512-1.46.686.316z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m10.24 16.652 1.23-.938-.512-.555zM14.794 9.022l1.23-.937-.512-.556z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m14.794 9.022.511-1.46.687.316z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m14.257 7.365 1.271.88.37-.658z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m14.256 7.365 1.547.035-.089.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m15.665 6.342-.444 1.481.74.148z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m15.665 6.342.444 1.481-.74.148z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m16.535 9.022-1.23-.937.512-.556z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m16.535 9.022-.511-1.46-.687.316z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m17.074 7.365-1.272.88-.37-.658z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m17.074 7.365-1.546.035.088.75zM13.24 12.317l-.512-1.46-.687.316z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m13.24 12.317-1.23-.937.511-.556z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m11.498 12.317 1.23-.937-.512-.556z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m11.498 12.317.511-1.46.687.316z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m10.96 10.66 1.271.88.37-.658z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m10.96 10.66 1.546.035-.088.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m13.777 10.661-1.272.88-.37-.658z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m13.777 10.661-1.546.035.088.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m12.368 9.638.444 1.481-.74.148z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m12.368 9.638-.444 1.481.74.148zM13.78 19.571l-1.546.035.088.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m13.78 19.571-1.272.88-.37-.658z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m13.242 21.227-.511-1.46-.687.316z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m13.242 21.227-1.23-.937.512-.555z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m11.5 21.227 1.23-.937-.512-.555z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m11.5 21.227.511-1.46.687.316z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m12.37 18.548.445 1.481-.741.148z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m12.37 18.548-.444 1.481.74.148z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m10.961 19.571 1.547.035-.088.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m10.962 19.571 1.271.88.37-.658zM16.995 22.553l-1.547.035.088.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m16.995 22.553-1.272.88-.37-.658z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m16.457 24.209-.511-1.46-.687.315z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m16.457 24.209-1.23-.938.512-.555z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m14.715 24.209 1.23-.938-.512-.555z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m14.715 24.209.511-1.46.687.315z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m15.585 21.53.444 1.48-.74.149z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m15.585 21.53-.444 1.48.74.149z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m14.176 22.553 1.546.035-.088.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m14.176 22.553 1.272.88.37-.658zM28.889 13.973l.444 1.481-.74.148z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m28.889 13.973-.445 1.481.741.148z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m27.479 14.996 1.546.035-.088.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m27.48 14.996 1.27.88.37-.658z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m28.018 16.652.511-1.46.686.316z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m28.017 16.652 1.23-.938-.511-.555z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m30.298 14.996-1.547.035.088.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m30.297 14.996-1.271.88-.37-.658z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m29.759 16.652-.512-1.46-.686.316z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m29.759 16.652-1.23-.938.512-.555zM25.205 9.022l-1.23-.937.512-.556z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m25.205 9.022-.511-1.46-.687.316z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m25.743 7.365-1.272.88-.37-.658z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m25.743 7.365-1.546.035.088.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m24.334 6.342.444 1.481-.74.148z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m24.334 6.342-.444 1.481.74.148z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m23.464 9.022 1.23-.937-.512-.556z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m23.464 9.022.511-1.46.687.316z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m22.925 7.365 1.272.88.37-.658z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m22.925 7.365 1.546.035-.087.75zM26.76 12.317l.511-1.46.686.316z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m26.76 12.317 1.23-.937-.512-.556z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m28.501 12.317-1.23-.937.512-.556z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m28.5 12.317-.51-1.46-.687.316z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m29.04 10.66-1.272.88-.37-.658z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m29.04 10.66-1.547.035.088.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m26.222 10.661 1.272.88.37-.658z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m26.222 10.661 1.546.035-.088.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m27.631 9.638-.445 1.481.741.148z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m27.63 9.638.445 1.481-.74.148zM26.22 19.571l1.545.035-.088.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m26.22 19.571 1.271.88.37-.658z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m26.757 21.227.511-1.46.687.316z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m26.757 21.227 1.23-.937-.512-.555z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m28.5 21.227-1.231-.937.512-.555z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m28.499 21.227-.511-1.46-.687.316z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m27.629 18.548-.444 1.481.74.148z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m27.629 18.548.444 1.481-.74.148z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m29.038 19.571-1.547.035.088.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m29.038 19.571-1.272.88-.37-.658zM23.004 22.553l1.547.035-.088.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m23.005 22.553 1.271.88.37-.658z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m23.542 24.209.511-1.46.687.315z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m23.542 24.209 1.23-.938-.512-.555z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m25.284 24.209-1.23-.938.512-.555z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m25.284 24.209-.511-1.46-.687.315z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m24.414 21.53-.444 1.48.74.149z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m24.414 21.53.444 1.48-.74.149z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m25.823 22.553-1.546.035.088.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FC0",
  d: "m25.823 22.553-1.272.88-.37-.658z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "eu-flag_svg__a"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 30,
  y: 0.311,
  fill: "#fff",
  rx: 6
})))));
export { SvgEuFlag as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZDk1NzNkMGJkMzc1ODcwNTk0YTRmY2M4OTRhNDU3NDEuc3ZnIjs=";